import Icon from '../components/Icon.vue'

Icon.register({
  'caret-square-left': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80V432C448 458.5 426.5 480 400 480zM259.5 124.5L136.5 247.5C131.8 252.2 131.8 259.8 136.5 264.5L259.5 387.5C267.1 395.1 280 389.7 280 379V133C280 122.3 267.1 116.9 259.5 124.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/caret-square-left.js
// module id = MDkV
// module chunks = 144